/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AdditionalFields/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AdditionalFields({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/AdditionalFields"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let questionIdValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'id',
})
let questionExternalResourceValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'external_resource',
})
let selectedQuestionTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'question_type_id',
})
let aggregateData = fromHelpers.getView(questionIdValueData, questionExternalResourceValueData, selectedQuestionTypeIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}